module.exports = __webpack_public_path__ + "img/2701efb.jpg";